import React from 'react';

export const progressStepStatuses = {
  disabled: 'disabled',
  active: 'active',
  complete: 'complete',
};

function ProgressIndicatorItem(props) {
  const { first, last, title, status, 'data-test': dataTest } = props;

  const spacerStyle = () => {
    switch (status) {
      case 'disabled':
        return 'progress-bar-split__spacer--disabled';
      case 'active':
        return 'progress-bar-split__spacer--active';
      case 'complete':
        return 'progress-bar-split__spacer--complete';

      default:
        return '';
    }
  };
  const itemStyle = () => {
    switch (status) {
      case 'disabled':
        return 'progress-bar-split__item--disabled';
      case 'active':
        return 'progress-bar-split__item--active';
      case 'complete':
        return 'progress-bar-split__item--complete';

      default:
        return '';
    }
  };

  return (
    <React.Fragment>
      {first ? (
        ''
      ) : (
        <div
          className={'progress-bar-split__spacer ' + spacerStyle()}
          data-test="spacer-left"></div>
      )}
      <div
        className={'progress-bar-split__item ' + itemStyle()}
        data-test={dataTest || "item-container"}>
        <div
          className="progress-bar-split__item-indicator"
          data-test="item-indicator"></div>
        <div className="progress-bar-split__item-title" data-test="item-title">
          {title}
        </div>
      </div>
      {last ? (
        ''
      ) : (
        <div
          className={'progress-bar-split__spacer ' + spacerStyle()}
          data-test="spacer-right"></div>
      )}
    </React.Fragment>
  );
}

export default ProgressIndicatorItem;
